export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT';
export const SET_ANOTHER_PROJECT = 'SET_ANOTHER_PROJECT';
